import { PropsWithChildren } from "react";
import { Modal as ReactstrapModal, ModalBody, ModalHeader } from "reactstrap";

interface Params {
    title: string;
    isOpen: boolean;
    onToggle: () => void,
}

const Modal = ({ title, isOpen, onToggle, children }: PropsWithChildren<Params>) => {
    return (
        <ReactstrapModal isOpen={isOpen} toggle={onToggle}>
            <ModalHeader toggle={onToggle} tag="h4">
                {title}
            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
        </ReactstrapModal>
    );
};

export default Modal;
